import React from 'react';
import ProgressBar from '../../ProgressBar/containers/ProgressBar';
import logo from '../../../assets/Header/Logo Group.svg';
import logoPng from '../../../assets/Header/Logo Group.png';
import logoDark from '../../../assets/Header/Logo Group Dark.svg';
import { ReactComponent as PhoneIcon } from '../../../assets/Header/call.svg';
import PropTypes from 'prop-types';
import './Header.css';
import queryString from 'query-string';
import { isMacOS } from './../../../utils/isMacOS';
import { isFirefox } from './../../../utils/isFirefox';
import { useTheme } from '../../../context/ThemeContext';

class Header extends React.Component {
  state = {
    phone: "800-644-2926",
    mobileViewPhone: "800 644 2926"
  };

  componentDidUpdate() {
    this.refs.top.scrollIntoView(true);
  }

  componentDidMount() {
    const params = queryString.parse(window.location.search);
    if(params["phone"])
      sessionStorage.setItem('phone', params["phone"]);
    
    if(sessionStorage.getItem("phone"))
      this.setState({phone: sessionStorage.getItem("phone"), mobileViewPhone: sessionStorage.getItem("phone")})
  }

  render() {
    const isDark = this.props.theme === 'dark';
    const logoSrc = isDark ? logoDark : (!isMacOS() && isFirefox() ? logoPng : logo);
    return (
      <header ref="top" className={"d-flex align-items-center content"}>
        <div className={`col-md-3 d-md-flex h-auto px-0`}>
          <figure className="logo mb-0 py-2">
            {this.props.logoLink ?
            <a href="https://choicemutual.com" target="_parent" rel="noopener noreferrer">
              <img src={logoSrc} alt="Company Logo" />
            </a> 
            : 
            <img src={logoSrc} alt="Company Logo" />}
          </figure>
        </div>
        {<div className="col-md-6 d-none d-md-flex mdProggressBarContainer">
          {this.props.progressBar && <ProgressBar />}
        </div>}

        {<div
          className="col-6 col-md-3 px-0 d-flex justify-content-end"
        >
          <div className="row contact text-center mx-0 text-sm-right">
            <div className="col-12 px-0">
              <span className='d-block'>Speak to a licensed agent:</span>
            </div>
            <div className="col-12 d-flex text-center phoneWrapper px-0 justify-content-center align-items-center">
              <a className="d-flex" href={`tel:${this.state.phone}`}>
              <span className="svg-phone me-2"><PhoneIcon className="" /></span>
              {this.state.phone}
              </a>
            </div>
          </div>
        </div>}
      </header>
    );
  }
}

Header.propTypes = {
  mode: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
};

function HeaderWithTheme(props) {
  const { theme } = useTheme();
  return <Header {...props} theme={theme} />;
}

export default HeaderWithTheme;
